import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ShapeState } from '../../../../../../cross-team-shared/annotation/shared/state/shape-state';

@Component({
  selector: 'h3-shape-list',
  templateUrl: './shape-list.component.html',
  styleUrls: ['./shape-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ShapeListComponent {
  @Input({ required: true }) shapeItems!: ShapeState[];
}
